module.exports = __webpack_public_path__ + "img/benoit19.d1a34d80.jpg";